import { portal } from './portal.js';

export { portal };
